import React, { JSX, useState } from "react";
// import MUIRichTextEditor from 'mui-rte'
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";
import LzXBaseField from "../BaseField/BaseField";

import "./RicheditorField.scss";

export interface LzPRicheditorField {
    fluid?: boolean,
    required?: boolean,
    initiallyShowHtml?: boolean,
    placeholder?: string,
    label?: string,
    name?: string,
    icon?: JSX.Element,
    id?: string,
    className?: string,
    style?: React.CSSProperties,
    value?: string,
    onChange?: (name: string, value: string) => void
}

const LzXRicheditorField = (props: LzPRicheditorField) => {

    if (typeof props.value === 'undefined') {
        return <CircularProgress />;
    }

    const [showHtml, setShowHtml] = useState(!!props.initiallyShowHtml);

    const theName = props.name || '';
    const theId = props.id || 'id_' + theName;

    const handleOnChange = (val: string): void => {
        if (props.onChange) {
            props.onChange(theName, val);
        }
    };

    return (
        <LzXBaseField
            id={theId}
            fluid={props.fluid}
            required={props.required}
            icon={props.icon}
            name={props.name}
            label={props.label}
        >

            <label style={{
                position: "absolute",
                marginTop: -25,
                right: 50,
                fontSize: 12,
            }}>
                <input type="checkbox" value={1} checked={showHtml} onChange={() => setShowHtml(!showHtml)} /> Show HTML Only
            </label>

            {showHtml ?
                <TextField multiline
                    required={props.required}
                    minRows={12}
                    name={props.name || ''}
                    className={'lz-textarea ' + (props.className ? props.className : '')}
                    style={props.style || {}}
                    value={props.value}
                    onChange={(evt) => handleOnChange(evt.target.value)}
                />
                :
                <div>
                    UNDER CONSTRUCTION
                    {/*<MUIRichTextEditor lang="en" name={props.name}
                        defaultValue={props.value}
                        onChange={(state: any) => handleOnChange(state.getCurrentContent())}
                        className={'lz-textarea ' + (props.className ? props.className : '')}
                        style={props.style || {}}
                    />*/}
                </div>
            }

        </LzXBaseField>
    );
};

export default LzXRicheditorField;
